var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "catalog-category" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.catalogCategories") }],
            select: true,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticClass: "custom-checkbox2",
              attrs: { content: _vm.$t("message.showCatalogCategories") },
            },
            [
              _c(
                "a-switch",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.catalogVisible,
                    callback: function ($$v) {
                      _vm.catalogVisible = $$v
                    },
                    expression: "catalogVisible",
                  },
                },
                [
                  _c("a-icon", {
                    attrs: { slot: "checkedChildren", type: "check" },
                    slot: "checkedChildren",
                  }),
                  _vm._v(" "),
                  _c("a-icon", {
                    attrs: { slot: "unCheckedChildren", type: "close" },
                    slot: "unCheckedChildren",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.openCatalog")))]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.catalog-form",
                  modifiers: { "catalog-form": true },
                },
              ],
              staticClass: "actionButtonBreadcrumb",
              on: { click: _vm.setCatalogInitialObj },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.changeTitle")) +
                  "\n        "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.catalogVisible
        ? _c("b-container", { attrs: { fluid: "" } }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "div",
                  { staticClass: "titleAlign" },
                  [
                    _c(
                      "md-button",
                      { staticClass: "arrow-class", on: { click: _vm.back } },
                      [_c("md-icon", [_vm._v("arrow_back")])],
                      1
                    ),
                    _vm._v(" "),
                    _vm.navigation.length
                      ? _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$_.last(_vm.navigation).languageContent[
                                  _vm.$i18n.locale
                                ].name
                              ) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.catalogTitle)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "menus" },
                  _vm._l(_vm.catalogs, function (cat) {
                    return _vm.catalogs.length
                      ? _c(
                          "div",
                          { staticClass: "menu" },
                          [
                            _c("CatalogMenu", {
                              attrs: {
                                data: cat,
                                "navigate-to": _vm.navigateTo,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.navigation.length &&
                _vm.navigation[_vm.navigation.length - 1].type === "content"
                  ? _c("CatalogContent", {
                      attrs: {
                        data: _vm.navigation[_vm.navigation.length - 1],
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                (_vm.navigation.length &&
                  _vm.navigation[_vm.navigation.length - 1].type === "menu") ||
                !_vm.navigation.length
                  ? _c(
                      "div",
                      { staticClass: "newButtons" },
                      [
                        !_vm.isCreateMenu
                          ? _c(
                              "div",
                              {
                                staticClass: "newMenu",
                                style: _vm.isCreateContent
                                  ? "display: none;"
                                  : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.onCreateCatalog()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("message.addNewMenu")) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _vm.isCreateMenu
                          ? _c(
                              "b-tabs",
                              _vm._l(_vm.languages, function (lang, i) {
                                return _c(
                                  "b-tab",
                                  { key: i, attrs: { title: lang.name } },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.catalogForm.languageContent[
                                              lang.code
                                            ].name,
                                          expression:
                                            "catalogForm.languageContent[lang.code].name",
                                        },
                                      ],
                                      staticClass: "newMenu",
                                      attrs: {
                                        id: "menuFocus",
                                        placeholder: _vm.$t(
                                          "message.pleaseTitleEnter"
                                        ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value:
                                          _vm.catalogForm.languageContent[
                                            lang.code
                                          ].name,
                                      },
                                      on: {
                                        keydown: _vm.handleKeyDown,
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.catalogForm.languageContent[
                                              lang.code
                                            ],
                                            "name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "actionsButtonCancel",
                                        on: { click: _vm.cancelMenu },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("message.cancel")) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "actionsButton",
                                        on: { click: _vm.saveMenu },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("message.save")) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isCreateContent
                          ? _c(
                              "div",
                              {
                                staticClass: "newMenu",
                                style: _vm.isCreateMenu ? "display: none;" : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.onCreateCatalog("content")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("message.content")) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _vm.isCreateContent
                          ? _c(
                              "b-tabs",
                              _vm._l(_vm.languages, function (lang, i) {
                                return _c(
                                  "b-tab",
                                  { key: i, attrs: { title: lang.name } },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.catalogForm.languageContent[
                                              lang.code
                                            ].name,
                                          expression:
                                            "catalogForm.languageContent[lang.code].name",
                                        },
                                      ],
                                      staticClass: "newMenu",
                                      attrs: {
                                        id: "contentFocus",
                                        placeholder: _vm.$t(
                                          "message.pleaseTitleEnter"
                                        ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value:
                                          _vm.catalogForm.languageContent[
                                            lang.code
                                          ].name,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.catalogForm.languageContent[
                                              lang.code
                                            ],
                                            "name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("ckeditor", {
                                      attrs: {
                                        editor: _vm.editor,
                                        config: _vm.editorConfig(),
                                      },
                                      model: {
                                        value:
                                          _vm.catalogForm.languageContent[
                                            lang.code
                                          ].content,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.catalogForm.languageContent[
                                              lang.code
                                            ],
                                            "content",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "catalogForm.languageContent[lang.code].content",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "actionsButton",
                                        on: { click: _vm.cancelContent },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("message.cancel")) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "actionsButton",
                                        on: { click: _vm.saveContent },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("message.save")) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _c(
            "div",
            [
              _c("a-result", {
                attrs: { title: _vm.$t("message.catalogNotOpen") },
                scopedSlots: _vm._u([
                  {
                    key: "extra",
                    fn: function () {
                      return [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.catalogVisible = true
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("message.openTheCatalog")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "catalog-form",
            title: _vm.$t("message.changeTitle"),
            centered: "",
            "hide-footer": "",
            size: "lg",
          },
          on: { hidden: _vm.resetTitle },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-card",
                            { attrs: { "no-body": "" } },
                            [
                              _c(
                                "b-tabs",
                                { attrs: { card: "", "no-fade": "" } },
                                _vm._l(_vm.languages, function (language) {
                                  return _c(
                                    "b-tab",
                                    {
                                      key: "tab" + language.code,
                                      attrs: { title: language.name },
                                    },
                                    [
                                      _c(
                                        "b-form",
                                        {
                                          staticClass:
                                            "d-flex flex-column justify-content-center",
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "catalog-input-group",
                                                label:
                                                  _vm.$t("message.catalog"),
                                                "label-for": "catalog-input",
                                              },
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "catalog-input",
                                                  autocomplete: "off",
                                                  trim: "",
                                                  type: "text",
                                                },
                                                model: {
                                                  value:
                                                    _vm.catalogTitleInit[
                                                      language.code
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.catalogTitleInit,
                                                      language.code,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "catalogTitleInit[language.code]",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { md: "12" } }, [
                        _c(
                          "div",
                          { staticClass: "catalog-action-buttons" },
                          [
                            _c(
                              "b-button",
                              {
                                staticStyle: { "margin-right": "6px" },
                                attrs: { variant: "primary" },
                                on: { click: _vm.handleTitleSave },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("message.update")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                on: {
                                  click: function () {
                                    return this$1.$bvModal.hide("catalog-form")
                                  },
                                },
                              },
                              [
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.cancel")) +
                                      "\n                                "
                                  ),
                                ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }